const redirectUrlParams = Object.freeze({
  extLocation: 'ext-location',
  loginIdentityLevel: 'login_identity_level',
  process: 'process',
  registerIdentityLevel: 'register_identity_level',
  returnTo: 'returnTo',
  skipEmailVerification: 'skip_email_verification'
});
export const buildRedirectUrl = (url, options) => {
  if (options) {
    Object.entries(options).forEach(_ref => {
      let [key, value] = _ref;
      url.searchParams.set(redirectUrlParams[key], value);
    });
  }
  return url;
};
export const isClientSide = () => Boolean(typeof window !== 'undefined') && Boolean(window.document);